import { render, staticRenderFns } from "./BindHistory.vue?vue&type=template&id=6e0056b5&"
import script from "./BindHistory.vue?vue&type=script&lang=js&"
export * from "./BindHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports